/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSanctionType } from './ApiSanctionType';
import {
    ApiSanctionTypeFromJSON,
    ApiSanctionTypeFromJSONTyped,
    ApiSanctionTypeToJSON,
    ApiSanctionTypeToJSONTyped,
} from './ApiSanctionType';
import type { ApiScreeningHitIdentity } from './ApiScreeningHitIdentity';
import {
    ApiScreeningHitIdentityFromJSON,
    ApiScreeningHitIdentityFromJSONTyped,
    ApiScreeningHitIdentityToJSON,
    ApiScreeningHitIdentityToJSONTyped,
} from './ApiScreeningHitIdentity';
import type { ApiScreeningHitCountryRelation } from './ApiScreeningHitCountryRelation';
import {
    ApiScreeningHitCountryRelationFromJSON,
    ApiScreeningHitCountryRelationFromJSONTyped,
    ApiScreeningHitCountryRelationToJSON,
    ApiScreeningHitCountryRelationToJSONTyped,
} from './ApiScreeningHitCountryRelation';
import type { ApiScreeningListEntryInfo } from './ApiScreeningListEntryInfo';
import {
    ApiScreeningListEntryInfoFromJSON,
    ApiScreeningListEntryInfoFromJSONTyped,
    ApiScreeningListEntryInfoToJSON,
    ApiScreeningListEntryInfoToJSONTyped,
} from './ApiScreeningListEntryInfo';
import type { ApiScreeningMatchProvider } from './ApiScreeningMatchProvider';
import {
    ApiScreeningMatchProviderFromJSON,
    ApiScreeningMatchProviderFromJSONTyped,
    ApiScreeningMatchProviderToJSON,
    ApiScreeningMatchProviderToJSONTyped,
} from './ApiScreeningMatchProvider';

/**
 * 
 * @export
 * @interface ApiScreeningSearchHit
 */
export interface ApiScreeningSearchHit {
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningSearchHit
     */
    id: string;
    /**
     * 
     * @type {ApiScreeningSearchHitTypeEnum}
     * @memberof ApiScreeningSearchHit
     */
    type: ApiScreeningSearchHitTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningSearchHit
     */
    recordDate: string;
    /**
     * 
     * @type {ApiSanctionType}
     * @memberof ApiScreeningSearchHit
     */
    screeningType: ApiSanctionType;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningSearchHit
     */
    matchData: string;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningSearchHit
     */
    highlight?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiScreeningSearchHit
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningSearchHit
     */
    sanctionList: string;
    /**
     * 
     * @type {ApiScreeningMatchProvider}
     * @memberof ApiScreeningSearchHit
     */
    matchProvider?: ApiScreeningMatchProvider;
    /**
     * 
     * @type {Array<ApiScreeningHitIdentity>}
     * @memberof ApiScreeningSearchHit
     */
    identities: Array<ApiScreeningHitIdentity>;
    /**
     * 
     * @type {Array<ApiScreeningHitCountryRelation>}
     * @memberof ApiScreeningSearchHit
     */
    countryRelations: Array<ApiScreeningHitCountryRelation>;
    /**
     * 
     * @type {Array<ApiScreeningListEntryInfo>}
     * @memberof ApiScreeningSearchHit
     */
    representedInLists: Array<ApiScreeningListEntryInfo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiScreeningSearchHit
     */
    descriptions: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ApiScreeningSearchHit
     */
    identificationDetails: { [key: string]: string; };
}

/**
* @export
* @enum {string}
*/
export enum ApiScreeningSearchHitTypeEnum {
    PERSON = 'PERSON',
    ENTITY = 'ENTITY',
    UNKNOWN = 'UNKNOWN'
}


/**
 * Check if a given object implements the ApiScreeningSearchHit interface.
 */
export function instanceOfApiScreeningSearchHit(value: object): value is ApiScreeningSearchHit {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('recordDate' in value) || value['recordDate'] === undefined) return false;
    if (!('screeningType' in value) || value['screeningType'] === undefined) return false;
    if (!('matchData' in value) || value['matchData'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('sanctionList' in value) || value['sanctionList'] === undefined) return false;
    if (!('identities' in value) || value['identities'] === undefined) return false;
    if (!('countryRelations' in value) || value['countryRelations'] === undefined) return false;
    if (!('representedInLists' in value) || value['representedInLists'] === undefined) return false;
    if (!('descriptions' in value) || value['descriptions'] === undefined) return false;
    if (!('identificationDetails' in value) || value['identificationDetails'] === undefined) return false;
    return true;
}

export function ApiScreeningSearchHitFromJSON(json: any): ApiScreeningSearchHit {
    return ApiScreeningSearchHitFromJSONTyped(json, false);
}

export function ApiScreeningSearchHitFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningSearchHit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'recordDate': json['recordDate'],
        'screeningType': ApiSanctionTypeFromJSON(json['screeningType']),
        'matchData': json['matchData'],
        'highlight': json['highlight'] == null ? undefined : json['highlight'],
        'score': json['score'],
        'sanctionList': json['sanctionList'],
        'matchProvider': json['matchProvider'] == null ? undefined : ApiScreeningMatchProviderFromJSON(json['matchProvider']),
        'identities': ((json['identities'] as Array<any>).map(ApiScreeningHitIdentityFromJSON)),
        'countryRelations': ((json['countryRelations'] as Array<any>).map(ApiScreeningHitCountryRelationFromJSON)),
        'representedInLists': ((json['representedInLists'] as Array<any>).map(ApiScreeningListEntryInfoFromJSON)),
        'descriptions': json['descriptions'],
        'identificationDetails': json['identificationDetails'],
    };
}

export function ApiScreeningSearchHitToJSON(json: any): ApiScreeningSearchHit {
    return ApiScreeningSearchHitToJSONTyped(json, false);
}

export function ApiScreeningSearchHitToJSONTyped(value?: ApiScreeningSearchHit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'recordDate': value['recordDate'],
        'screeningType': ApiSanctionTypeToJSON(value['screeningType']),
        'matchData': value['matchData'],
        'highlight': value['highlight'],
        'score': value['score'],
        'sanctionList': value['sanctionList'],
        'matchProvider': ApiScreeningMatchProviderToJSON(value['matchProvider']),
        'identities': ((value['identities'] as Array<any>).map(ApiScreeningHitIdentityToJSON)),
        'countryRelations': ((value['countryRelations'] as Array<any>).map(ApiScreeningHitCountryRelationToJSON)),
        'representedInLists': ((value['representedInLists'] as Array<any>).map(ApiScreeningListEntryInfoToJSON)),
        'descriptions': value['descriptions'],
        'identificationDetails': value['identificationDetails'],
    };
}

